
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import SliderWithTitle from "../../components/slider-with-title";
import { BLOG, create_link } from "../../constants";
import NoPage from "../404";


export default function BlogItem() {

    const location = useLocation();
    const { pathname } = location;



    // const { id } = use(params);
    const blog = BLOG.filter((blog) => {
        return create_link(blog.title) === pathname.split("/")[2];
    });

    return (
        <div>
            <div className="py-16 container">
                {blog.length === 0 ? <NoPage /> : (
                    <div>
                        <h1 className="text-3xl font-semibold mb-6">{blog[0].title}</h1>
                        <div className="flex flex-col lg:flex-row gap-8">
                            <div className="w-full lg:w-2/3">
                                <SliderWithTitle blog={blog[0]} />
                                <p className="text-lg mt-5 whitespace-pre-line">
                                    {blog[0].description}
                                </p>
                            </div>
                            <div className="w-full lg:w-1/3">
                                <div className="recent">
                                    <h2 className="text-2xl font-medium">Recent Posts</h2>
                                    <div className="mt-5 flex flex-col gap-3">
                                        {BLOG.map((b, i) => (
                                            <Link
                                                to={`/blog/${create_link(b.title)}`}
                                                key={i}
                                                className="flex items-center"
                                            >
                                                <MdOutlineKeyboardArrowRight className="text-xl" />
                                                <p>{b.title}</p>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
